export default __webpack_public_path__ + "static/media/logout.77d3aee3.svg";